"use client";
import { j as r } from "../../jsx-runtime-B6kdoens.js";
import { useState as C, useCallback as k } from "react";
import { createPortal as A } from "react-dom";
import { w as S } from "../../atom-provider-B3P183Tj.js";
import { c as i, a as N } from "../../index-CROKJrb5.js";
import { c as E, f as I } from "../../create-component-CBAeEoQ6.js";
import { a as R, b as T, u as z, c as B } from "../../use-trap-focus-jtnCyC_f.js";
import { Button as D } from "../Button/index.js";
import { ModalHeader as P } from "./ModalHeader/index.js";
import { M as V } from "../../motion-jk0ivqSc.js";
import { u as Y } from "../../use-merge-refs-DEJnLwh4.js";
import { CrossIcon as F } from "../Icon/icons/CrossIcon/index.js";
import { createModalState as W, ModalContext as H, useModalStateAtoms as K } from "./ModalState/index.js";
import { useBrand as L } from "../../brand/context/index.js";
import { u } from "../../use-sync-atom-value-CDr7vapO.js";
import { A as O } from "../../index-LYq8AemS.js";
import { m } from "../../motion-minimal-Crg_qVxv.js";
const q = () => (z(!0), null), G = ({
  el: t,
  initialSelector: a
}) => (B(t, !0, a), null), J = i({
  base: "cur-bottom-0 cur-absolute cur-w-full cur-left-0 cur-flex cur-flex-col cur-items-center",
  variants: {
    brand: {
      curology: "",
      agency: ""
    },
    compact: {
      true: "cur-h-[calc(100%-env(safe-area-inset-top))]",
      false: "cur-h-[calc(100%-3rem-env(safe-area-inset-top))]"
    },
    type: {
      dark: "cur-bg-surface-brand",
      light: "cur-bg-surface-primary"
    }
  },
  compoundVariants: [
    {
      brand: "agency",
      class: "cur-bg-surface-brand-light"
    }
  ]
}), Q = i({
  base: "cur-relative cur-flex cur-h-full lg:cur-max-w-6xl cur-max-w-[100vw] cur-grow cur-flex-col focus-visible:cur-outline-0 focus-visible:cur-ring-0 focus-visible:cur-ring-transparent focus-visible:cur-ring-offset-0 focus-visible:cur-ring-offset-transparent cur-px-4 lg:cur-px-6",
  variants: {
    brand: {
      curology: "",
      agency: ""
    },
    type: {
      dark: "cur-text-inverse",
      light: ""
    }
  },
  compoundVariants: [
    {
      brand: "agency",
      class: "cur-text-primary"
    }
  ]
}), U = i({
  base: "cur-flex cur-items-start cur-justify-between cur-gap-2",
  variants: {
    compact: {
      true: "cur-my-3",
      false: "cur-mb-6 cur-mt-12 lg:cur-mb-12"
    }
  }
}), X = {
  initial: { opacity: 0 },
  animate: {
    opacity: 1,
    transition: {
      duration: 0.1,
      delay: 0.25
    }
  },
  exit: { opacity: 0 },
  transition: { type: "linear" }
}, Z = {
  initial: { opacity: 0, translateY: "100%" },
  animate: {
    opacity: 1,
    translateY: "0%"
  },
  exit: {
    opacity: 0,
    translateY: "100%",
    transition: {
      duration: 0.25,
      delay: 0.1
    }
  },
  transition: { ease: "easeInOut" }
}, br = S(
  E(
    "Modal",
    I(
      ({
        autoFocus: t,
        children: a,
        className: d,
        compact: e = !1,
        contentStyle: f,
        onClose: s,
        open: o = !1,
        title: c,
        type: l = "dark",
        width: p,
        ...b
      }, x) => {
        const n = L();
        R("Escape", s, { enabled: o });
        const [g, y] = C(null), h = k(
          (M) => y(M),
          []
        ), v = Y(x, h);
        T(o);
        const { compactAtom: j, contentStyleAtom: w } = K();
        return u(j, e), u(w, f), typeof window != "object" ? null : A(
          /* @__PURE__ */ r.jsx(V, { children: /* @__PURE__ */ r.jsx(O, { children: o ? /* @__PURE__ */ r.jsxs(
            "div",
            {
              ref: v,
              ...b,
              className: N(
                "cur-fixed cur-left-0 cur-top-0 cur-z-[250] cur-h-full cur-w-full",
                d
              ),
              children: [
                /* @__PURE__ */ r.jsx(q, {}),
                /* @__PURE__ */ r.jsx(G, { el: g, initialSelector: t }),
                /* @__PURE__ */ r.jsx(
                  m.div,
                  {
                    "aria-hidden": !0,
                    className: "cur-absolute cur-left-0 cur-top-0 cur-z-0 cur-h-full cur-w-full cur-backdrop-blur-sm",
                    tabIndex: -1,
                    onClick: s,
                    title: "Close",
                    ...X
                  }
                ),
                /* @__PURE__ */ r.jsx(
                  m.div,
                  {
                    role: "dialog",
                    "aria-modal": !0,
                    className: J({
                      brand: n,
                      compact: e,
                      type: l
                    }),
                    "data-testid": "modal-inner-container",
                    ...Z,
                    children: /* @__PURE__ */ r.jsxs(
                      "div",
                      {
                        className: Q({ brand: n, type: l }),
                        style: {
                          width: p || "100%"
                        },
                        tabIndex: 0,
                        "data-testid": "modal-content",
                        children: [
                          /* @__PURE__ */ r.jsxs("div", { className: U({ compact: e }), children: [
                            typeof c == "string" ? /* @__PURE__ */ r.jsx(P, { children: c }) : c,
                            /* @__PURE__ */ r.jsx(
                              D,
                              {
                                icon: /* @__PURE__ */ r.jsx(F, {}),
                                title: "Close",
                                onClick: s,
                                size: "sm",
                                buttonType: "secondary",
                                className: "cur-shrink-0"
                              }
                            )
                          ] }),
                          a
                        ]
                      }
                    )
                  }
                )
              ]
            }
          ) : null }) }),
          document.body
        );
      }
    )
  ),
  H,
  W
);
export {
  br as Modal
};
//# sourceMappingURL=index.js.map
